var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    attrs: {
      "role": "img",
      "width": _vm.currentWidth,
      "height": _vm.currentHeight,
      "viewBox": _vm.viewBox
    }
  }, [_vm.title ? _c('title', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('use', {
    attrs: {
      "xlink:href": _vm.iconName
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };